// Текстовки для интро панели

const DO_YOU_WANT = 'Хочешь, чтобы твой любимый мультфильм, телеведущий или ТВ-проект победил в Премии?';
const GIVE_YOUR_VOICE = 'Заполняй форму и предлагай нам своих претендентов!';
const MAY_BE = 'Возможно, именно они станут Главными Героями этого года!';

export const INTRO_TEXT = [DO_YOU_WANT, GIVE_YOUR_VOICE, MAY_BE];

// Константы для веба

export const VK_MINI_APP_ID = 52074531;
export const VK_MINI_APP_ID_TEST = 52074531;
export const APP_URL = 'https://vk.com/app51549281';
// export const APP_URL = 'https://vk.com/app51696453'; // Тестовое

export const VK_SHARE_URL = `https://vk.com/app${VK_MINI_APP_ID}`;
export const VK_SHARE_TITLE = 'Я выбрал главных героев! А ты?';

export const WEB_SHARE_URL = `https://www.karusel-tv.ru/${APP_URL}`;
export const WEB_SHARE_TITLE = 'Я выбрал главных героев! А ты?';
